<template>
  <div class="container-earning-rules" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" :title="$t('lang.earnRule.earningRules')" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <div class="main">
      <div v-for="(item, index) in list" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="con">{{ item.con }}</div>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('lang.earnRule.hungUpBy') }}</th>
              <th>{{ $t('lang.earnRule.callDuration') }}</th>
              <th>{{ $t('lang.earnRule.settlementRatio') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in item.tableTdList" :key="index">
              <td>{{ item.td1 }}</td>
              <td>{{ item.td2 }}</td>
              <td>{{ item.td3 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: this.$t('lang.sevenKeepSignin.more3'),
          con: this.$t('lang.earnRule.con1'),
          tableTdList: [
            {
              td1: this.$t('lang.earnRule.girl'),
              td2: '0-29s',
              td3: '0%'
            },
            {
              td1: '',
              td2: '30s',
              td3: '100%'
            },
            {
              td1: this.$t('lang.earnRule.boy'),
              td2: '0-60s',
              td3: '100%'
            }
          ]
        },
        {
          title: this.$t('lang.earnRule.tit2'),
          con: this.$t('lang.earnRule.con2'),
          tableTdList: [
            {
              td1: this.$t('lang.earnRule.girl'),
              td2: '0-9s',
              td3: '0%'
            },
            {
              td1: '',
              td2: '10-60s',
              td3: '100%'
            },
            {
              td1: this.$t('lang.earnRule.boy'),
              td2: '0-60s',
              td3: '100%'
            }
          ]
        }
      ]
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.container-earning-rules {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
  background: #080215;
  .main {
    margin: 0 12px;
    font-family: Inter-Regular;
    .title {
      margin-top: 20px;
      font-weight: 600;
      font-family: Inter-Regular;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
    .con {
      margin: 12px 0 16px 0;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 15px;
    }
    .table {
      width: 100%;
      border-collapse: collapse;
      text-align: center;
      line-height: 43px;
      background-color: #251b3c;
      tr {
        display: flex;
        th,
        td {
          flex: 1;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  color: #fff;
  font-family: F-Medium;
}
</style>
